module.exports = __webpack_public_path__ + "static/media/copy.e0fa0d16.svg";